import { apiClient } from './client';

export interface VocabularyItem {
  tenantId: string;
  scopeKey: string;
  term: string;
  aliases: string[];
  category: string;
  scope: 'TENANT' | 'USER';
  userId?: string;
  source: 'MANUAL' | 'AUTO_LEARNED';
  status: 'ACTIVE' | 'PENDING_REVIEW' | 'REJECTED';
  createdBy: string;
  createdAt: string;
  reviewedBy?: string;
  reviewedAt?: string;
}

export interface AddVocabularyInput {
  term: string;
  aliases: string[];
  category: string;
  scope?: 'TENANT' | 'USER';
  userId?: string;
}

export const fetchVocabulary = async (): Promise<VocabularyItem[]> =>
  (await apiClient.get('/api/vocabulary')).data.items;

export const fetchPendingVocabulary = async (): Promise<VocabularyItem[]> =>
  (await apiClient.get('/api/vocabulary/pending')).data.items;

export const addVocabularyTerm = async (input: AddVocabularyInput): Promise<VocabularyItem> =>
  (await apiClient.post('/api/vocabulary', input)).data;

export const approveVocabularyTerm = async (scopeKey: string): Promise<VocabularyItem> =>
  (await apiClient.post(`/api/vocabulary/${encodeURIComponent(scopeKey)}/approve`)).data;

export const rejectVocabularyTerm = async (scopeKey: string): Promise<VocabularyItem> =>
  (await apiClient.post(`/api/vocabulary/${encodeURIComponent(scopeKey)}/reject`)).data;

export const deleteVocabularyTerm = async (scopeKey: string): Promise<void> => {
  await apiClient.delete(`/api/vocabulary/${encodeURIComponent(scopeKey)}`);
};
